module.exports = __webpack_public_path__ + "img/bird-eyeview.599a2c5a.jpg";